/**
 * Returns `true` when the given string represents a non-negative integer
 * (e.g. `"0"`, `"7"`) and `false` otherwise (negatives, decimals, blanks,
 * or any non-numeric / non-canonical input like `"007"` or `"3.0"`).
 */
export const isValidNonNegativeInteger = (value: string): boolean => {
  if (value === null || value === undefined) return false;
  const trimmed = value.trim();
  if (trimmed === '') return false;
  const num = Number(trimmed);
  return Number.isInteger(num) && num >= 0 && trimmed === String(num);
};
